import { render, staticRenderFns } from "./penaltyReport.vue?vue&type=template&id=3daa158c&scoped=true"
import script from "./penaltyReport.vue?vue&type=script&lang=js"
export * from "./penaltyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daa158c",
  null
  
)

export default component.exports